import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import Tabs from 'antd/lib/tabs';
import { getDiagnosticsCategories } from '../../API';
import { MonitoringDetails } from './components/MonitoringDetails';
import { config } from '../../config';

import './MonitoringPage.less';

const { REACT_APP_BUILD_ENV } = config;

export const MonitoringPage = (props) => {
  const { theme, buildings } = props;
  const { TabPane } = Tabs;
  const { search } = useLocation();
  const { building: buildingId } = useParams();
  const { category: categoryName } = queryString.parse(search);
  const history = useHistory();

  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState({});
  const [activeCategoryTabName, setActiveCategoryTabName] = useState('All');

  useEffect(() => {
    async function fetchCategories() {
      const monitoringCategories = await getDiagnosticsCategories(REACT_APP_BUILD_ENV, buildingId);

      const activeCategory = monitoringCategories.find(
        (item) => item.diagnostic_category.display_name === (!categoryName ? 'All' : categoryName),
      );

      setActiveCategory(activeCategory);
      setActiveCategoryTabName(!categoryName ? activeCategory.diagnostic_category.display_name : categoryName);
      setCategories(monitoringCategories);
    }
    if (buildingId) fetchCategories();
  }, [buildingId]);

  useEffect(() => {
    if (buildings.length > 0) {
      const sessionSelectedBuilding = JSON.parse(sessionStorage.getItem('selectedBuilding') || '{}');

      window.document.title = `${sessionSelectedBuilding.name} | Monitoring`;
    }
  }, [buildings, buildingId]);

  const clearCustomData = (activeKey) => {
    const activeCategory = categories.find((item) => item.diagnostic_category.display_name === activeKey);
    setActiveCategory(activeCategory);
    setActiveCategoryTabName(activeCategory.diagnostic_category.display_name);

    // sessionStorage.removeItem('customDataPoints');
    // sessionStorage.setItem('clearData', false);
    history.replace(`/monitoring/${buildingId}?category=${activeKey}`);
  };

  return (
    <div id="monitoring-page">
      <div className="monitoring-page-wrapper">
        <div className="monitoring-page-header">
          <Tabs
            className={`app-tabs-${theme}`}
            activeKey={activeCategoryTabName}
            defaultActiveKey="All"
            onChange={(activeKey) => clearCustomData(activeKey)}
          >
            {categories.map((item) => {
              const { diagnostic_category: diagnosticCategory } = item;

              return (
                <TabPane tab={diagnosticCategory.display_name} key={diagnosticCategory.display_name}>
                  <MonitoringDetails
                    category={item}
                    activeCategory={activeCategory}
                    buildingId={buildingId}
                    theme={theme}
                  />
                </TabPane>
              );
            })}
          </Tabs>
        </div>
      </div>
    </div>
  );
};
